import { render, staticRenderFns } from "./pdf-document.vue?vue&type=template&id=5d8ada26&scoped=true"
import script from "./pdf-document.vue?vue&type=script&lang=ts"
export * from "./pdf-document.vue?vue&type=script&lang=ts"
import style0 from "./pdf-document.vue?vue&type=style&index=0&id=5d8ada26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ada26",
  null
  
)

export default component.exports